import React from "react";
import dotenv from "dotenv";
import { createRoot } from "react-dom/client";
import "./translate/config";
import App from "./App";
import 'common/styles/antd.css';

dotenv.config();
const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
